import { EditorModes, isSystemPart, ReviewType } from "@buildwithflux/models";
import { ElementHelper } from "../../elements";
import { getAllLeafElementNodes } from "../../nodes";
import { getIsExcludedFromBOM, getManufacturerPartNumberProperty } from "../../property";
import { getProblemTypeKeyFromReviewType } from "../types";
export class ManufacturePartNumberValidator {
    reviewType = ReviewType.DesignRuleCheckManufacturePartNumber;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    async checkForProblems({ documentUid, elements, pcbLayoutNodes }) {
        // This skips element nodes that are submodules themselves.
        const elementNodes = getAllLeafElementNodes(pcbLayoutNodes);
        const elementNodeUidsWithMissingMpn = elementNodes
            .filter((elementNode) => {
            // We're typecasting here because we know for certain the elementNode will not be
            // a submodule itself, so the remaining type can only be IElementData or undefined.
            const elementData = ElementHelper.getNestedElementData(elements, elementNode.uid);
            if (!elementData) {
                return false;
            }
            if (isSystemPart(elementData.part_uid)) {
                return false;
            }
            if (!ElementHelper.isValidLayoutElement(elementData, documentUid)) {
                return false;
            }
            if (getIsExcludedFromBOM(elementData.properties)) {
                return false;
            }
            const mpnProperty = getManufacturerPartNumberProperty(elementData.properties);
            return !mpnProperty || !mpnProperty.value || mpnProperty.value.toString().trim() === "";
        })
            .map((elementNode) => elementNode.uid);
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: elementNodeUidsWithMissingMpn.map((elementUid) => ({
                problemTypeKey: this.problemTypeKey,
                key: `${this.problemTypeKey}_${elementUid}`,
                affectedItems: [{ type: "element", uid: elementUid }],
                affectedViews: [EditorModes.pcb, EditorModes.schematic],
            })),
        };
    }
}
//# sourceMappingURL=ManufacturePartNumberValidator.js.map